import React, { useMemo } from "react";
import { useTheme, Grid, Stack, Typography } from "@mui/material";
import { GridRowIdGetter, GridRowModel } from "@mui/x-data-grid-pro";

import useIsMobile from "helpers/hooks/useIsMobile";
import { useTranslations } from "@fenetech/translations";
import DataGridColumnGenerator from "components/Common/DataGridColumnGenerator";
import { addColumns } from "components/LineItemPriceBreakdown/LineItemPriceBreakdownColumns"
import { ILineItemPriceBreakdownProps } from "components/LineItemPriceBreakdown/LineItemPriceBreakdown"
import CustomDataGridPro from "components/Common/CustomDataGridPro";
import useApplicationInfo from "helpers/context/Application/useApplicationInfo";

const PBOptionsGrid: React.FC<ILineItemPriceBreakdownProps> = ({editEnabled, discountTable, optionsData, setEditingOption, cf}) => {
    const appInfo = useApplicationInfo();
    const tm = useTranslations();
    const isMobile = useIsMobile();
    const theme = useTheme();
    
    const columns = useMemo(() => {
        const generator = new DataGridColumnGenerator(tm, optionsData, theme, isMobile);
        addColumns(generator, isMobile, editEnabled, setEditingOption, cf, tm, appInfo.parameters.hideOptionCodes);
        return generator.GetColumns();
    }, [tm, optionsData, theme, isMobile, editEnabled, setEditingOption, cf, appInfo.parameters.hideOptionCodes]);

    const getRowId: GridRowIdGetter = (row: GridRowModel) => row["index"];

    return <>
        <Grid container direction="column" justifyItems="stretch">
            <Grid item>
                <Stack direction="row" justifyContent="space-between">
                    {optionsData.length > 0 && 
                        <Typography>{tm.Get("Option Prices") + ":"}</Typography>
                    }
                    {discountTable !== "" &&
                        <Typography>{tm.Get("Discount Table") + ": " + discountTable}</Typography>
                    }
                </Stack>
            </Grid>
            {optionsData.length > 0 && 
                <Grid item>
                    <CustomDataGridPro
                        getRowId={getRowId}
                        columns={columns}
                        rows={optionsData}
                        disableColumnFilter
                        tableName="PBOptions"
                        tableSubName={isMobile ? "Mobile" : ""}
                    />
                </Grid>
            }
        </Grid>
    </>
}

export default PBOptionsGrid